
namespace Gordic.Vyp.Dialogs {

    /**
     * Otevře prehled vypravencych
     * 
     * @author  JSindelka
     * @date    7.1.2019
     *
     * @param {gcontent} parentContent The content.
     * @param {?Gordic.Global.Enums.ModOtevreni=Gordic.Gin.Globals.Enums.Navigate} modOtevreni Mód otevření dialogu.
     * @param {!object} opt Parametry dialogu.
     * @returns {JQueryPromise<undefined>} Promise.
     */
    export function OpenProvedenaVypraveniDlg(
        parentContent: GContent,
        opt?: { TridVyp: number, ZpusobDor: Wfl.Interface.WflczpdEnum },
        ModOtevreni?: Gordic.Global.Enums.ModOtevreni
    ): JQueryPromise<boolean | undefined> {
        const options = {
            Id: "ProvedenaVypraveniZasilekObsahListPage#",
            TridVyp: opt ? opt.TridVyp : "",
            ZpusobDorProp: opt ? opt.ZpusobDor : ""
        };
        const deferred = $.Deferred();
        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);
        const windowParams: GDialogOptions | undefined = undefined;

        let isValid = true;
        if (isValid) {
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, 'Gordic.Vyp.WebControls.ProvedenaVypraveniZasilekObsahListPage', ModOtevreni, options, windowParams);
        } else {
            deferred.reject();
        }

        return deferred.promise();
    }

    export function EditaceZasilkyDlg(
        parentContent: GContent,
        opt: { data: Wfl.Interface.GEditaceZasilkyDto },
        ModOtevreni?: Gordic.Global.Enums.ModOtevreni
    ): JQueryPromise<Wfl.Interface.GEditaceZasilkyDto> {

        const options = {
            ID: "EditaceZasilkyDlg#",
            Data: opt ? opt.data : null,
        };

        const deferred = $.Deferred();
        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

        const windowParams: GDialogOptions | undefined = undefined;

        let isValid = true;
        if (isValid) {
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, 'Gordic.Vyp.WebControls.EditaceZasilkyDlg', ModOtevreni, options, windowParams);
        } else {
            deferred.reject();
        }

        return deferred.promise();
    }

    export function PredplneniZasilkyDlg(
        parentContent: GContent,
        opt: { data: Wfl.Interface.GPredplneniZasilekDto },
        ModOtevreni?: Gordic.Global.Enums.ModOtevreni
    ): JQueryPromise<Wfl.Interface.GPredplneniZasilekDto> {

        const options = {
            ID: "PredplneniZasilkyDlg#",
            Predplneni: opt ? opt.data : null,
        };

        const deferred = $.Deferred();
        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

        const windowParams: GDialogOptions | undefined = undefined;

        let isValid = true;
        if (isValid) {
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, 'Gordic.Vyp.WebControls.PredplneniZasilkyDlg', ModOtevreni, options, windowParams);
        } else {
            deferred.reject();
        }

        return deferred.promise();
    }

    export function CenikSluzebDlg(
        parentContent: GContent,
        ModOtevreni?: Gordic.Global.Enums.ModOtevreni
    ): JQueryPromise<Wfl.Interface.GEditaceZasilkyDto> {

        const options = {
            ID: "GCenikSluzebDlg#",
            Typ: Wfl.Interface.TypCenikuPosty.cenikPostovnichSluzeb
        };

        const deferred = $.Deferred();
        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

        const windowParams: GDialogOptions | undefined = undefined;

        let isValid = true;
        if (isValid) {
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, 'Gordic.Vyp.WebControls.GCenikDlg', ModOtevreni, options, windowParams);
        } else {
            deferred.reject();
        }

        return deferred.promise();
    }

    export function CenikZasilekDlg(
        parentContent: GContent,
        ModOtevreni?: Gordic.Global.Enums.ModOtevreni
    ): JQueryPromise<Wfl.Interface.GEditaceZasilkyDto> {

        const options = {
            ID: "CenikZasilekDlg#",
            Typ: Wfl.Interface.TypCenikuPosty.cenikZasilek
        };

        const deferred = $.Deferred();
        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

        const windowParams: GDialogOptions | undefined = undefined;

        let isValid = true;
        if (isValid) {
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, 'Gordic.Vyp.WebControls.GCenikDlg', ModOtevreni, options, windowParams);
        } else {
            deferred.reject();
        }

        return deferred.promise();
    }

    export function EditacePolozkyCenikuDlg(
        parentContent: GContent,
        opt: { Detail: Wfl.Interface.GCenikPostyDetailDto },
        ModOtevreni?: Gordic.Global.Enums.ModOtevreni
    ): JQueryPromise<Wfl.Interface.GCenikPostyDetailDto> {

        const options = {
            ID: "EditacePolozkyCenikuDlg#",
            Detail: opt ? opt.Detail : null,
        };

        const deferred = $.Deferred();
        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

        const windowParams: GDialogOptions | undefined = undefined;

        let isValid = true;
        if (isValid) {
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, 'Gordic.Vyp.WebControls.EditacePolozkyCenikuDlg', ModOtevreni, options, windowParams);
        } else {
            deferred.reject();
        }

        return deferred.promise();
    }

    /**
* automaticke ukladani
*
* @author  JSindelka
* @date    22.11.2019
*
* @param {gcontent} parentContent The content.
* @param {?Gordic.Global.Enums.ModOtevreni=Gordic.Gin.Globals.Enums.Navigate} modOtevreni Mód otevření dialogu.
* @param {!object} opt Parametry dialogu.
* @returns {JQueryPromise<undefined>} Promise.
*/
    export function DataMatrixCteckaCallDlg(
        parentContent: GContent,
        opt?: { DataMatrixDto: Wfl.Interface.GDataMatrixDto; },
        ModOtevreni?: Gordic.Global.Enums.ModOtevreni
    ): JQueryPromise<Wfl.Interface.GDataMatrixDto | undefined> {
        const options = {
            Id: "DataMatrixCteckaDlg#",
            DataMatrixDto: opt ? opt.DataMatrixDto : undefined
        };
        const deferred = $.Deferred();
        const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
        ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);
        const windowParams: GDialogOptions | undefined = undefined;

        let isValid = true;
        if (isValid) {
            Gordic.Gui.Dialogs._openDialog(pContent, deferred, 'Gordic.Vyp.WebControls.DataMatrixCteckaDlg', ModOtevreni, options, windowParams);
        } else {
            deferred.reject();
        }

        return deferred.promise();
    }

}

